import { headerStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsHeader";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

headerStyles.container = {
    gap: 15,
};
headerStyles.infoGridItem = {
    width: 12,
    css: css`
        align-items: flex-end;
        font-size: 14px;
        @media print {
            justify-content: flex-start;
            flex-direction: row !important;
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        flex-direction: column;
                        align-items: flex-start;
                        ${TypographyStyle} {
                            padding-left: 0;
                        }
                    `,
                    null,
                    null,
                    css`
                        justify-content: flex-start;
                    `,
                ],
                "max",
            )}
    `,
};
headerStyles.descriptionStyles = {
    heading: {
        size: 14,
        color: "text.main",
        weight: "bold",
        css: css`
            text-transform: capitalize;
        `,
    },
    text: {
        size: 16,
    },
};
headerStyles.totalText = {
    weight: "bold",
    css: css`
        padding-left: 30px;
        @media print {
            font-weight: 500 !important;
        }
    `,
};
